"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getConfig;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
function getConfig() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _p$config = p.config,
    config = _p$config === void 0 ? {} : _p$config;
  var commonConfig = config.common || {};
  var globalsConfig = config.globals || {};
  var globals = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, globalsConfig), {}, {
    DEV: typeof globalsConfig.DEV !== "undefined" ? globalsConfig.DEV : typeof DEV !== "undefined" ? DEV : false,
    WAPP: typeof globalsConfig.WAPP !== "undefined" ? globalsConfig.WAPP : typeof WAPP !== "undefined" ? WAPP : "buildHash",
    RUN: typeof globalsConfig.RUN !== "undefined" ? globalsConfig.RUN : typeof RUN !== "undefined" ? RUN : "",
    TYPE: typeof globalsConfig.TYPE !== "undefined" ? globalsConfig.TYPE : typeof TYPE !== "undefined" ? TYPE : "",
    ROOT: typeof globalsConfig.ROOT !== "undefined" ? globalsConfig.ROOT : typeof ROOT !== "undefined" ? ROOT : typeof __dirname !== "undefined" ? __dirname : "/",
    NAME: typeof globalsConfig.NAME !== "undefined" ? globalsConfig.NAME : typeof NAME !== "undefined" ? NAME : ""
  });
  var common = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, commonConfig), {}, {
    containerElementId: commonConfig.containerElementId ? commonConfig.containerElementId : typeof globals.WAPP !== "undefined" && globals.WAPP ? typeof globals.DEV !== "undefined" && globals.DEV ? "wapplr-container-element-id-" + globals.WAPP : "app-" + globals.WAPP : "app",
    appStateName: commonConfig.appStateName ? commonConfig.appStateName : typeof globals.WAPP !== "undefined" && globals.WAPP ? typeof globals.DEV !== "undefined" && globals.DEV ? "WAPPLR_APP_STATE_" + globals.WAPP : globals.WAPP : "APP_STATE",
    siteName: commonConfig.siteName || "Wapplr",
    lang: commonConfig.lang || "en"
  });
  return {
    config: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, config), {}, {
      globals: globals,
      common: common
    })
  };
}